<template>
    <div class="hint">
        <!-- <ThButton
            type="link"
            @click="hint"
        >
            Hint this design💡
        </ThButton>

        <p
            v-if="hinted"
            class="hint-message"
        >
            Thanks for your interest in “hinting” this design! We’re testing
            this feature. Stay tuned for more ways to share designs you like.
        </p> -->
    </div>
</template>

<script setup lang="ts">
// import { computed, ref } from 'vue'

// import { useSegment } from '@/third-party/segment'
// import { getWindow } from '@/helpers/globals'

// const hinted = ref(false)

// const { track } = useSegment()

// const hint = () => {
//     if (hinted.value) {
//         return
//     }

//     hinted.value = true

//     const url = getWindow()?.location.href

//     if (!url) {
//         return
//     }

//     const event_name = 'hint_click'

//     track(`custom_${event_name}`, {
//         param1: 'Hint this design',
//         param2: event_name,
//         param3: '',
//         param4: url,
//         url,
//         event_name,
//     })
// }

// const classHint = computed(() => ({
//     'hinted': hinted.value,
// }))
</script>

<style scoped lang="scss">
// .hint {
//     padding: 8px;
//     margin-top: 1rem;
//     text-align: center;

//     &.hinted {
//         background-color: $stone-2;
//     }

//     .hint-message {
//         margin-top: 0.5rem;
//         font-size: 0.875rem;
//     }
// }
</style>
